<template>
  <div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="bank_info.user_identity_card_name"
		      label="业务员名称"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="amount"
		      label="提现金额(元)"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="create_time"
		      label="申请时间"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="提现状态"
		      align="center"
        >
          <template slot-scope="scope">
          	 <span v-if="scope.row.status ==='1'">待审核</span>
          	 <span v-if="scope.row.status ==='2'">已通过</span>
          	 <span v-if="scope.row.status ==='3'">已拒绝</span>
          </template>
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="160"
        >
         <template slot-scope="scope">
         	  <span class="opration-item" @click="detailClick(scope.row)" v-if="have_detail_auth">查看详情</span>
         </template>
		    </el-table-column>
		  </el-table>
			  <common-pagination
		    :total="total"
	      :page_size="page_size"
		    @size-change="handelPagesizeChange"
		    @page-change="handlePageChange"
		  ></common-pagination>
    </div>
  </div>
</template>

<script>
import { withdrawList } from '@/api/finance-manage';
import CommonPagination from '@/components/CommonPagination';
import { mapState } from 'vuex';

export default {
  name: 'withdraw-manage',
  data() {
  	return {
  		tableData: [],
  		page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
      three_rules: [],
      have_detail_auth: false, //是否具有查看详情权限
  	}
  },
  components: {
  	CommonPagination,
  },
  computed: {
    ...mapState(['operationList']),
  },
  mounted() {
    this.getWithdrawList();
    this.handleThreeRules();
  },
  methods: {
  	async getWithdrawList() {
  		let postData = {
  			page_index: this.page_index,
  			page_size: this.page_size
  		}
      const { status, data } = await withdrawList(postData);
      if ( status !== 200 ) return
      this.total = data.total;
      this.tableData = data.data;
      console.log(data, 'list dd')
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this.getWithdrawList();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this.getWithdrawList();
  	},
  	detailClick(row) {
  		this.$router.push({
  			path:'/withdraw-manage/withdraw-detail',
  			query: {
  				uuid: row.uuid
  			}
  		})
  	},
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      if (this.three_rules.length) {
        this.have_detail_auth = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.table-wrap {
	margin-top: 30px;
	.opration-item {
		cursor: pointer;
		color: @color-text;
	}
}
</style>
